<template>
  <div>
    <ReportsGetStartedInstructions />
    <div :class="$style.content">
      <h2 :class="$style.title">
        Stored Reports Queue
      </h2>
      <ReportDownloadsPreview />
      <h2 :class="$style.title">
        Reports
      </h2>
      <ReportTypeSelector
        @reportTypeSelectionEvent="(value) => {reportTypeChanged(value)}"
      />
      <ReportFilters
        v-if="$hasFeatureFlag($featureFlags.reportFiltration)"
        @filterEvent="(value) => {filterChanged(value)}"
      />
      <ReportExportContainer
        v-if="reportType"
        :filters="filters"
        :reportType="reportType"
      />
    </div>
  </div>
</template>

<script>
import MainPanelMixin from 'components/MainPanel/mixins/MainPanelMixin';
import ReportDownloadsPreview from 'client/Reports/components/ReportDownloadsPreview.vue';
import ReportExportContainer from 'client/Reports/components/ReportExportContainer.vue';
import ReportFilters from 'client/Reports/components/ReportFilters.vue';
import ReportTypeSelector from 'client/Reports/components/ReportTypeSelector.vue';
import ReportsGetStartedInstructions from 'client/Reports/components/ReportsGetStartedInstructions.vue';

export default {
  name: 'ReportsMainPanel',

  components: {
    ReportDownloadsPreview,
    ReportExportContainer,
    ReportFilters,
    ReportTypeSelector,
    ReportsGetStartedInstructions,
  },

  mixins: [MainPanelMixin],

  data: () => ({
    reportType: '',
    filters: [],
  }),
  methods: {
    filterChanged(value) {
      this.filters = value;
    },
    reportTypeChanged(value) {
      this.reportType = value;
    },
  },
};
</script>

<style module>
.content {
  padding: 0 20px;
}

h2.title {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 4px;
}
</style>
